import classnames from 'classnames';
import type { FC, ReactNode } from 'react';

interface MenuProps {
  horizontal?: boolean;
  className?: string;
  children: ReactNode;
}

const Menu: FC<MenuProps> = ({ className, children }) => {
  return <ul className={classnames('flex flex-col gap-2', className)}>{children}</ul>;
};

export default Menu;
